import React from 'react';
import styles from './TableContent.module.scss';
import { XPagination } from '@/components/xqxc_ui';
import { Table, Tooltip } from 'antd';
import PropTypes from 'prop-types';
import { tooltipStyle, tooltip, tooltipClick, cellWidth } from '@/components/TableCell';
import moment from 'moment';

const TableContent = ({
    renderData: {
        dataList = [],
        pageNum = 1,
        pageSize = 30,
        resultTotal = 0
    } = {},
    tableAction,
    paginationChange
}) => {

    const tableOperate = (text, item) => {
        return (
            <div className={styles.action}>
                <div className={styles.item} onClick={() => tableAction('detail', item)}>详情</div>
                {item.status == 'FAIL' ? <div className={styles.item} onClick={() => tableAction('edit', item)}>修改</div> : null}
            </div>
        );
    };

    const companyInfo = (id, item) => {
        return <dl className={styles.companyCard}>
            <dt><img src={item.transportLogo} /></dt>
            <dd>
                <p><Tooltip title={item.transportName}>{item.transportName}</Tooltip></p>
                <p><Tooltip title={item.id}>{item.id}</Tooltip></p>
            </dd>
        </dl>;
    };

    const contactInfo = (key, item) => {
        return <div className={styles.contactCard}><p>{item.contactName}</p><p>{item.tel}</p></div>;
    };

    const columns = [
        {
            title: '站点信息',
            dataIndex: 'id',
            key: 'id',
            width: cellWidth.normal,
            align: 'center',
            onCell: tooltipStyle,
            render: companyInfo
        },
        {
            title: '联系人',
            dataIndex: 'tel',
            key: 'tel',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: contactInfo
        },
        {
            title: '骑手数量',
            dataIndex: 'riderNum',
            key: 'riderNum',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '结算模式',
            dataIndex: 'settleTypeDesc',
            key: 'settleTypeDesc',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '协议有效期',
            dataIndex: 'agrtEndTime',
            key: 'agrtEndTime',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '区域运营',
            dataIndex: 'zoneOperationDesc',
            key: 'zoneOperationDesc',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '状态',
            dataIndex: 'statusDesc',
            key: 'statusDesc',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '运营中心',
            dataIndex: 'opName',
            key: 'opName',
            width: '100px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '创建时间',
            dataIndex: 'gmtCreate',
            key: 'gmtCreate',
            width: '150px',
            align: 'center',
            onCell: tooltipStyle,
            render: tooltip
        },
        {
            title: '操作',
            dataIndex: 'id',
            key: 'id',
            align: 'center',
            width: '100px',
            fixed: 'right',
            render: tableOperate
        },
    ];

    return <div className={styles.tableContainer} style={{ height: '100%' }}>
        <Table
            rowClassName={(record, index) => index % 2 === 0 ? '' : styles.tdcolor}
            rowKey={item => item.id}
            columns={columns}
            dataSource={dataList}
            pagination={false}
            scroll={{ y: true }}
        />
        <XPagination
            resultTotal={resultTotal}
            pageSize={pageSize}
            pageNum={pageNum}
            onChange={paginationChange}
        />
    </div>;
};

TableContent.propTypes = {
    renderData: PropTypes.object.isRequired, // 表格数据源
    tableAction: PropTypes.func.isRequired, // 表格操作
    paginationChange: PropTypes.func.isRequired, // 分页操作
};

export default TableContent;

